import React, { Component, Fragment } from 'react';
import { get } from 'lodash';
import queryString from 'query-string';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Label, FormGroup, Row, Col, ModalFooter, Button, Collapse } from 'reactstrap';
import * as Yup from 'yup';
import { Formik, Field, Form as FormikForm } from 'formik';
import {
  displayToaster,
  hideToaster, toggleDrawer,
  GET_DOCUMENT_PREVIEW_URL,
  clearLoadingState,
  LOADING_PROP_TYPE,
  createSimpleSignDocument,
  createOnboardingSimpleSignDocument,
  CREATE_SIMPLE_SIGN_DOCUMENT,
  CREATE_ONBOARDING_SIMPLE_SIGN_DOCUMENT,
} from '../../modules';
import {
  Drawer,
  DrawerHeader,
  UnsupportedError,
  LockedModalBody,
  SubmitButton,
  FileViewer,
  ErrorMessage,
} from '../../components';
import { APPLICATION_ROOT } from '../../constants';
import { downloadFromUrl, setFileUrl } from '../../helpers';
import './SimpleSignDocuments.scss';

const assetsBaseUrl = `${process.env.REACT_APP_DOMAIN}/assets/media`;


class SimpleSignDocuments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSignaturePanel: false,
      fileCleared: false,
      fullName: '',
      title: '',
      errMsg: '',
    };
    this.handleDrawer = this.handleDrawer.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {
      loading,
    } = this.props;
    const { loading: prevLoading } = prevProps;
    if ((prevLoading[CREATE_SIMPLE_SIGN_DOCUMENT] === 'loading' && loading[CREATE_SIMPLE_SIGN_DOCUMENT] === 'complete') ||
    (prevLoading[CREATE_ONBOARDING_SIMPLE_SIGN_DOCUMENT] === 'loading' && loading[CREATE_ONBOARDING_SIMPLE_SIGN_DOCUMENT] === 'complete')) {
      this.handleDrawer();
    }
  }

  onSubmit(selectedDocument) {
    const isOnboardingUrl = /^.*\/onboarding.aspx(?:\?[^?]*$)?$/i;
    const onboardingKey = get(window, 'asure.appSettings.esignature.onboarding.key') || queryString.parse(window.location.search).onboardingkey;
    if (onboardingKey && isOnboardingUrl.test(window.location.href)) {
      this.props.createOnboardingSimpleSignDocument(selectedDocument.id);
    } else {
      this.props.createSimpleSignDocument(selectedDocument.id);
    }
    // Trigger an event to notify ADHR 2.0 that a document has been signed.
    const signedDocs = new Set(window.asure.appSettings.esignature.onboarding.signedDocs);
    signedDocs.add(selectedDocument.id);
    window.asure.appSettings.esignature.onboarding.signedDocs = [...signedDocs];
    document.dispatchEvent(new Event('onboardingDocSigned'));
  }

  handleChange(event) {
    this.setState({ fullName: event.target.value });
  }

  handleDrawer() {
    const { drawerIsOpen } = this.props;

    this.props.toggleDrawer(!drawerIsOpen);
    this.props.hideToaster('drawer');
    this.props.clearLoadingState(CREATE_SIMPLE_SIGN_DOCUMENT);
    this.props.clearLoadingState(CREATE_ONBOARDING_SIMPLE_SIGN_DOCUMENT);
    // Allowing the drawer to close before resetting state makes for a cleaner animation
    setTimeout(() => this.setState(this.state), 500);
  }

  handleAddSignatureChange = () => {
    this.setState({
      showSignaturePanel: !this.state.showSignaturePanel,
    });
  }
  render() {
    const {
      loading,
      drawerIsOpen,
      selectedDocument,
      filePreview: { url, mimeType },
    } = this.props;
    const isSubmitting = loading[CREATE_SIMPLE_SIGN_DOCUMENT] === 'loading' || loading[CREATE_ONBOARDING_SIMPLE_SIGN_DOCUMENT] === 'loading';
    const containerClasses = ['w-100', 'h-100'];
    const isLoading = loading[GET_DOCUMENT_PREVIEW_URL] === 'loading';
    if (isLoading) {
      containerClasses.push('hello-sign-container');
      containerClasses.push('loading');
    }
    const fileUrl = setFileUrl(url);
    let documentPreview;
    if (!isLoading) {
      if (fileUrl) {
        documentPreview = (
          <div className={containerClasses.join(' ')} style={{ boxShadow: '1px solid rgba(0, 0, 0, 0.5)' }} >
            <FileViewer
              fileType={(mimeType && mimeType.replace('.', '')) || ''}
              filePath={fileUrl || ''}
              unsupportedComponent={
                () => (
                  <UnsupportedError
                    messageId="FILE_COULD_NOT_BE_PREVIEWED"
                    ctaMessageId="DOWNLOAD"
                    onClick={() => downloadFromUrl(fileUrl, selectedDocument.fileName)}
                    classes="p-3"
                  />
                )
              }
              loadingComponent={() => (
                <div className="file-viewer-loading d-flex h-100 w-100" />
              )}
            />
          </div>
        );
      } else {
        documentPreview = (
          <div
            className={`d-flex align-items-center flex-column justify-content-center pb-5 ${containerClasses.join(' ')}`}
            style={{ boxShadow: '1px solid rgba(0, 0, 0, 0.5)' }}
          >
            <div className="text-center">
              <img src={`${assetsBaseUrl}/warning.svg`} alt="" />
            </div>
            <h5 className="text-center pt-5 h4"><FormattedMessage id="PREVIEW_UNAVAILABLE" /></h5>
            <div className="text-center text-muted pt-2"><FormattedMessage id="PREVIEW_UNAVAILABLE_DOWNLOAD_AND_SIGN" /></div>
            <Button
              color="primary"
              className="btn mt-5"
              onClick={() => downloadFromUrl(fileUrl, selectedDocument.fileName)}
            >
              <FormattedMessage id="DOWNLOAD" />
            </Button>
          </div>
        );
      }
    }
    const formData = {
      initialValues: {
        fullName: '',
      },
      validationSchema: Yup.object().shape({
        fullName: Yup.string().required('PLEASE_TYPE_YOUR_NAME'),
      }),
    };
    return (
      <Fragment>
        <Drawer
          modalClassName="drawer wider"
          toggle={this.handleDrawer}
          isOpen={drawerIsOpen}
          parentselector={APPLICATION_ROOT}
          backdrop={isLoading ? 'static' : true}
        >
          <DrawerHeader
            title={selectedDocument.title}
            toggle={this.handleDrawer.bind(this)}
            useFormattedMessage={false}
          />
          <Formik
            initialValues={formData.initialValues}
            validateOnChange={false}
            validateOnBlur={false}
            validationSchema={formData.validationSchema}
            onSubmit={() => this.onSubmit(selectedDocument)}
          >
            {({
                values,
                errors,
                handleChange,
                handleSubmit,
                setErrors,
              }) => {
                if (this.state.showSignaturePanel) {
                  // need to close the signature panel and clear errors when the user closes the entire drawer
                  if (!drawerIsOpen) {
                    setErrors({});
                    this.handleAddSignatureChange();
                  }
                // need to open the signature panel and show form validation errors if the user tries to submit while its closed
                } else if (errors.fullName) {
                  this.handleAddSignatureChange();
                }
                return (
                  <Fragment>
                    <Row className={`ml-0 ${this.state.showSignaturePanel ? 'hide-mobile' : ''}`} >
                      <div className="btn-link w-100 text-right small-text" id="download-row">
                        <div className="mt-2">
                          <button
                            tabIndex="0"
                            style={{ border: '0px', backgroundColor: '#ffffff' }}
                            onClick={() => downloadFromUrl(fileUrl, selectedDocument.fileName)}
                          >
                            <FormattedMessage id="DOWNLOAD" className="mt-2" />
                          </button>
                        </div>
                      </div>
                    </Row>
                    <LockedModalBody
                      style={{ backgroundColor: 'var(--color-neutral-100)' }}
                      className={`scale-for-safari ${this.state.showSignaturePanel ? 'hide-mobile' : ''}`}
                    >
                      <Row key="file-viewer" className="d-flex justify-content-center align-items-center h-100 w-100 p-3" >
                        <Col className="h-100 p-0" >
                          {documentPreview}
                        </Col>
                      </Row>
                    </LockedModalBody>
                    <Row className="d-flex w-100 mx-auto mt-auto mb-0">
                      <div className="w-100" id="add-sign-row">
                        <div className="text-center text-primary mt-3">
                          <button
                            className="border-0 bg-white"
                            onClick={() => {
                              setErrors({});
                              this.handleAddSignatureChange();
                            }}
                          >
                            <img src={`${assetsBaseUrl}/signature.svg`} alt="" className="pr-2" />
                            <FormattedMessage id="ADD_YOUR_SIGNATURE" />
                          </button>
                        </div>
                      </div>
                    </Row>
                    <Collapse isOpen={this.state.showSignaturePanel}>
                      <Row className="scrolldiv">
                        <Col md={{ size: 12 }} className="d-flex justify-content-center">
                          <div className="col-md-7 py-3">
                            <h5 className="mt-1 heading"><FormattedMessage id="ACKNOWLEDGEMENT" /></h5>
                            <p className="text-muted small-text"><FormattedMessage id="ESIGN_DISCLOSURES_BLURB" />
                              <span>
                                <a
                                  href={`${assetsBaseUrl}/CONSENT_TO_RECEIVE.pdf`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                > <FormattedMessage id="ESIGN_DISCLOSURES_LINK" />
                                </a>
                              </span>.
                            </p>
                            <FormikForm>
                              <Row>
                                <Col>
                                  <FormGroup>
                                    <Label className="required" for="fullName"><FormattedMessage id="TYPE_YOUR_FULL_NAME" />
                                    </Label>
                                    <Field
                                      name="fullName"
                                      type="text"
                                      className={!errors.fullName ? 'form-control' : 'form-control is-invalid'}
                                      value={values.fullName}
                                      onChange={handleChange}
                                      disabled={isSubmitting}
                                    />
                                    <ErrorMessage errorText={errors.fullName} />
                                  </FormGroup>
                                </Col>
                              </Row>
                            </FormikForm>
                          </div>
                        </Col>
                      </Row>
                    </Collapse>
                    <ModalFooter>
                      <SubmitButton
                        onSubmit={handleSubmit}
                        defaultLabel="ACCEPT_SIGN"
                        submittingLabel="SIGNING"
                        submitting={isSubmitting}
                        disabled={isSubmitting}
                      />
                    </ModalFooter>
                  </Fragment>
                );
              }
            }
          </Formik>
        </Drawer>
      </Fragment>
    );
  }
}

SimpleSignDocuments.defaultProps = {
  drawerIsOpen: false,
  selectedDocument: {},
};

SimpleSignDocuments.propTypes = {
  loading: LOADING_PROP_TYPE.isRequired,
  drawerIsOpen: PropTypes.bool,
  toggleDrawer: PropTypes.func.isRequired,
  hideToaster: PropTypes.func.isRequired,
  clearLoadingState: PropTypes.func.isRequired,
  filePreview: PropTypes.shape({
    url: PropTypes.string,
    filename: PropTypes.string,
  }).isRequired,
  selectedDocument: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    fileName: PropTypes.string,
    category: PropTypes.string,
    uploadDate: PropTypes.string,
    extension: PropTypes.string,
    isPublishedToEmployee: PropTypes.bool,
    companyId: PropTypes.number,
    companyName: PropTypes.string,
    employeeId: PropTypes.number,
    employeeName: PropTypes.string,
    uploadedBy: PropTypes.string,
    isLegacyDocument: PropTypes.bool,
    status: PropTypes.shape({
      name: PropTypes.string,
      priority: PropTypes.number,
      stepNumber: PropTypes.number,
      isProcessing: PropTypes.bool,
    }),
  }),
  createSimpleSignDocument: PropTypes.func.isRequired,
  createOnboardingSimpleSignDocument: PropTypes.func.isRequired,
};

export default connect(
  (state) => {
    const {
      resources: {
        docs: {
          filePreview,
          selectedDocument,
          docCategories,
        },
      },
      appState,
      user: {
        roles,
      },
    } = state;
    return {
      loading: appState.loading,
      drawerIsOpen: appState.drawer.isOpen,
      userRoles: roles,
      filePreview,
      selectedDocument,
      docCategories,
    };
  },
  {
    displayToaster: args => displayToaster(...args),
    toggleDrawer: open => toggleDrawer(open),
    hideToaster: location => hideToaster(location),
    clearLoadingState: action => clearLoadingState(action),
    createSimpleSignDocument: documentId => createSimpleSignDocument(documentId),
    createOnboardingSimpleSignDocument: documentId => createOnboardingSimpleSignDocument(documentId),
  }
)(hot(module)(SimpleSignDocuments));



// WEBPACK FOOTER //
// ./src/containers/SimpleSignDocuments/SimpleSignDocuments.jsx